export const downloadJson = ({ filename, payload }) => {
    const jsonData = JSON.stringify(payload);
    const file = new Blob([jsonData], { type: "application/json" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(file);
    a.download = `${filename}.json`;
    a.click();
};
